import React from 'react';

import sergei from '../audio/sergei.mp3';

import InternalPage from '../components/InternalPage';
import Hint from '../components/Hint';
import Peek from '../components/Peek';
import Blur from '../components/Blur';

import internalPageStyle from '../components/InternalPage/layout.module.css';

import SergeiHidden from '../images/Sergei-hidden.jpg';
import SergeiOver from '../images/Sergei-over.png';
import SergeiBlur from '../images/Sergei-blur.jpg';
import SergeiBlurOver from '../images/Sergei-blur-over.jpg';

const SergeiPage = () => (
  <InternalPage
    next="/gerda"
    name="Сергей"
    bio="Экономист, 32 года"
    audio={sergei}
    audioDuration={169}
  >
    <div className={internalPageStyle.titleContainer}>
      <h2 className={internalPageStyle.title}>
        ВИДЕЛ, КАК&nbsp;ДЕВУШКУ
        <br /> ПО&nbsp;КРУГУ ПУСКАЛИ
      </h2>
      <div className={internalPageStyle.topImage}>
        <Peek
          hiddenImage={SergeiHidden}
          overImage={SergeiOver}

          limitX={50}
          limitY={50}

          limitXLayer="0, -1000"
          limitYLayer="0, 1000"
          scale={1.2}

          limitXOverLayer="1000, 0"
          limitYOverLayer="-1000, 0"
          scaleOver={1.2}
        />
      </div>
    </div>

    <div className={internalPageStyle.textContainer}>
      <div className={internalPageStyle.text}>
        Порно смотрю лет десять, раньше раза три&mdash;четыре в&nbsp;неделю,
        сейчас реже. На&nbsp;порносайтах обычно выбираю классику, иногда страпон
        или&nbsp;
        <Hint definition="CFNM (Clothed Female, Naked Male &laquo;одетая женщина, голый мужчина&raquo;)&nbsp;&mdash; жанр эротики и&nbsp;ролевых сексуальных игр, предполагающий обнажение мужчины в&nbsp;присутствии одной или нескольких полностью одетых женщин.">
          CFNM
        </Hint>
        .
      </div>

      <p className={internalPageStyle.text}>
        Очень впечатлил один европейский фильм: на&nbsp;улице припаркован
        грузовичок с&nbsp;прозрачными стенами, и&nbsp;там пара сексом
        занимается, мимо люди идут. Красивая пара на&nbsp;красивом фоне выглядит
        привлекательно. Но&nbsp;вот они часами трахаются, и&nbsp;это развивает
        комплексы у&nbsp;неопытных людей: я-то так не&nbsp;смогу. Сейчас интерес
        к&nbsp;порносайтам немного угас.
      </p>

      <div className={internalPageStyle.text}>
        Чаще смотрю&nbsp;
        <Hint definition="Вебкам&nbsp;&mdash; общение веб-модели и&nbsp;наблюдателя в&nbsp;онлайн-видеочате на&nbsp;платной основе.">
          вебкам
        </Hint>
        , бесплатный раздел: приятный эффект присутствия и&nbsp;подглядывания
        за&nbsp;реальным человеком. За&nbsp;секс и&nbsp;шоу я&nbsp;никогда
        не&nbsp;платил. Только однажды модели за&nbsp;съёмку&nbsp;ню,
        но&nbsp;очень разочаровался результатом, она совершенно без души
        работала.
      </div>

      <p className={internalPageStyle.quote}>
        Летом я&nbsp;всё свободное время провожу на&nbsp;нудистском пляже.
      </p>

      <p className={internalPageStyle.text}>
        Видео про нудистов люблю, особенно снятое скрытой камерой у&nbsp;нас
        в&nbsp;Серебряном Бору: интересно увидеть знакомых. Это интереснее
        постановки, всё жизненно. Наблюдение за&nbsp;реальными людьми
        в&nbsp;реальной обстановке гораздо сильнее впечатляет, потом
        додумываешь, докручиваешь в&nbsp;голове, проецируешь ситуацию
        на&nbsp;себя.
      </p>

      <p className={internalPageStyle.text}>
        На&nbsp;пляже чего только не&nbsp;увидишь: один мужик привёл свою
        гёрлфренд, двое местных её&nbsp;ласкали, я&nbsp;фоткал, потом тоже
        потрогал. Видно было, как это их&nbsp;обоих заводило. Видел, как девушку
        по&nbsp;кругу пускали. Но&nbsp;групповые темы мне не&nbsp;очень, там,
        как&nbsp;бы выразиться... грязно, что&nbsp;ли, всё происходит. Долго
        и&nbsp;похотливо, без красоты и&nbsp;удовольствия. Я&nbsp;ушёл,
        искупался, позагорал, вернулся&nbsp;&mdash; а&nbsp;там всё то&nbsp;же.
      </p>

      <div className={internalPageStyle.middleImage}>
        <Blur image={SergeiBlur} imageBlur={SergeiBlurOver} />
      </div>

      <p className={internalPageStyle.text}>
        Мне нравится не&nbsp;только наблюдать, но&nbsp;и, наоборот, показывать
        женщинам своё тело. Бывать на&nbsp;пляже, позировать художницам,
        представлять себя порноактёром. Хочу сходить на&nbsp;медосмотр.
        Найти&nbsp;бы реальную медсестру или врача развратную, чтобы она провела
        осмотр и&nbsp;сбор спермы и&nbsp;ещё привела&nbsp;бы группу
        практиканток.
      </p>
    </div>
  </InternalPage>
);

export default SergeiPage;
